import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'feature',
    standalone: false
})
export class FeaturePipe implements PipeTransform 
{

  transform(item: string, attributes: any , geomname : string): any 
  {   

      //item === null ||  item.toString().trim().length === 1
     
      if ( geomname == attributes   || attributes.toString() === "layerID" || attributes.toString() === "showinfo" || attributes.toString().charAt(0) === "_" )
      {    
          return false;
      }    
      
      
      return true;
  }

}
